// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hydrapple: PokeData = {
  "id": 1019,
  "name": "hydrapple",
  "height": 18,
  "weight": 930,
  "base_experience": 270,
  "types": [
    PokeType.GRASS,
    PokeType.DRAGON
  ],
  "api_moves": [
    "growth",
    "recover",
    "withdraw",
    "substitute",
    "protect",
    "dragon-breath",
    "sweet-scent",
    "recycle",
    "astonish",
    "bullet-seed",
    "dragon-pulse",
    "energy-ball",
    "power-whip",
    "dragon-tail",
    "syrup-bomb",
    "fickle-beam"
  ],
  "moves": [
    "protect",
    "dragon-breath",
    "bullet-seed",
    "dragon-pulse",
    "energy-ball",
    "power-whip",
    "synthesis",
    "solar-beam",
    "dragon-dance",
    "dragon-vortex",
    "draco-meteor",
    "dragon-fang",
    "great-roar"
  ],
  "evolution_chain": {
    "id": 442,
    "item": null,
    "species": [
      {
        "name": "applin",
        "order": 840,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "flapple",
        "order": 841,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "tart-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "appletun",
        "order": 842,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sweet-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dipplin",
        "order": 1013,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "syrupy-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hydrapple",
        "order": 1021,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 1011,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "syrup-bomb"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 152,
    "speed": 67,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
